module.exports = __webpack_public_path__ + "img/atas_reunioes_encaminhamentos.c1941e13.png";